import CrudRepository from './CrudRepository'
export default class ProfileServicesRepository extends CrudRepository {
  constructor () {
    super('core/api/services/allActive')
  }
}
